var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M13.707.293c.39.39.39 1.025 0 1.415l-7.999 8c-.39.39-1.025.39-1.416 0l-4-4a1.001 1.001 0 0 1 1.416-1.416l3.294 3.29 7.293-7.29c.39-.39 1.025-.39 1.415 0z"
  })));
};
export default SvgCheck;